

const NotFoundPage = () => {
    return (
        <div className="flex justify-center items-center h-screen bg-gray-100 w-full">
            <div className="text-center p-6 bg-white rounded shadow-lg w-full">
                <h1 className="text-6xl font-bold text-red-600 mb-5">404</h1>
                <p className="text-2xl text-gray-700 mb-4">صفحه مورد نظر یافت نشد.</p>
               
                
            </div>
        </div>
    );
}

export default NotFoundPage;
